// dependencies
import { Map, fromJS } from "immutable";
import moment from "moment";

import { getUserID } from "../selectors/app";
// selectors
import { getPageName, getQueryParams, getURLParam } from "../selectors/navigation";

export const getPageUI = (state, notSetValue = Map()) => {
	const pageName = getPageName(state);
	return state.page.get(pageName, notSetValue);
};

export const getUI = (state) => getPageUI(state);

export const getCurrentEmployeeID = (state = {}) => {
	const employeeID = getURLParam(state, "employeeID");
	if (employeeID !== "created") {
		return employeeID || getUserID(state);
	}
	return getUserID(state);
};

export const getPageUISelector = (state, config) => state.page.get(config.pageName, Map());

export const getIsInitialized = (state, config) => getPageUISelector(state, config).get("initialized", false);

export const getPageStateValue = (state, pageValue) => state.page.getIn(pageValue);
